import { gql } from "@apollo/client";


export const CREATE_RESOURCE_URL_MUTATION = gql`mutation CreateResourceUrl($input: CreateResourceUrlInput!) {
  createResourceUrl(input: $input) {
    id
    url
  }
}`;


//{  "input": {    "resourceId",    "resourceUrlId"  }}"
export const DELETE_RESOURCE_URL_MUTATION = gql`
  mutation DeleteResourceUrl($input: DeleteResourceUrlInput!) {
    deleteResourceUrl(input: $input) {
      affectedRows
    }
  }
`;



